module.exports = __webpack_public_path__ + "static/img/test.ac0dfee3.png";